<template>
  <div class="content pr-2">
    <div class="columns">
      <div class="column is-12">
        <div class="is-flex justify-content-center align-center">
          <div
            class="box"
            style="background-color:#535353; color:#F8F8F8"
          >
            To ban/unban a member's account, please enter the member's name or AHL # below, or find the member in the
            list below<br><br>
            <div style="color:#535353">
              <div class="search-desktop">
                <span class="icon is-right">
                  <i class="far fa-search" />
                </span>
                <input
                  v-model="searchCriteria"
                  placeholder="Enter search criteria"
                  class="input-search"
                  type="text"
                >
              </div>
            </div>
          </div>
          <!--<router-link to="/admin/ahl-members/create" class="button button-tools is-mobile">-->
          <!--Add member-->
          <!--</router-link>-->
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <div
          v-if="loading"
          class="spinner-loader"
        >
          <sync-loader />
          <p>Loading ...</p>
        </div>
        <div
          v-for="member in chunkedMembers"
          v-if="!loading && !edit && !banModal && !unbanModal"
          class="box p-1 mb-0 is-radiusless"
        >
          <div class="border-bottom is-flex flex-row space-between relative align-center p-1">
            <div class="is-flex flex-row align-center">
              <img
                v-if="member.photo"
                :src="member.photo"
                class="img-circle mr-4"
              >
              <img
                v-if="!member.photo"
                src="/images/profile.png"
                class="img-circle mr-4"
              >
              <div class="ml-4">
                <router-link
                  :to="{path: `/players/${member.ahlid}`}"
                  class="mr-1 is-size-7-touch"
                >
                  {{ member.name }}
                </router-link>
                <small class="has-text-dark mr-1 is-block">{{ member.ahlid }}</small>
                <div
                  v-show="member.isBanned === '1'"
                  class="tag is-danger pointer"
                  @click="openUnbanModal(member)"
                >
                  Banned
                </div>
                <div v-if="member.isBanned">
                  Reason: {{ member.reason }}<br>
                  End Date: {{ member.duration }}
                </div>
                <!--<small class="mr-1">{{ member.city }} / {{ member.state }}</small>-->
                <!--<small class="has-text-info">Region: {{ member.region }}</small>-->
              </div>
            </div>
            <div>
              <a
                class="btn-icon tooltip"
                data-tooltip="Edit"
                @click="editMember(member)"
              >
                <i class="far fa-edit" />
              </a>
              <a
                v-show="!member.isBanned"
                class="btn-icon tooltip"
                data-tooltip="Ban Player"
                @click="openBanModal(member)"
              >
                <i class="far fa-ban has-text-danger" />
              </a>
              <a
                v-show="member.isBanned"
                class="btn-icon tooltip"
                data-tooltip="Unban Player"
                @click="openUnbanModal(member)"
              >
                <i class="far fa-check-circle has-text-success" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ban-player-modal
      v-if="banModal"
      :member="selectedMember"
      @banMember="banMember"
      @close="close"
    />
    <unban-player-modal
      v-if="unbanModal"
      :member="selectedMember"
      @unbanMember="unbanMember"
      @close="close"
    />
  </div>
</template>

<script>
  import BanPlayerModal from './BanPlayerModal.vue'
  import UnbanPlayerModal from './UnbanPlayerModal.vue'
  import axios from 'axios'

  export default {
    name: 'ToolsBannedMembers',
    components: {
      BanPlayerModal,
      UnbanPlayerModal
    },
    props: ['token', 'user'],
    data() {
      return {
        edit: false,
        selectedMember: {},
        members: [],
        searchCriteria: '',
        banModal: false,
        unbanModal: false,
        loading: false,
        timeout: null
      }
    },
    computed: {
      chunkedMembers() {
        return this.members.slice(0, 50)
      }
    },
    watch: {
      searchCriteria(val) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          if (val) {
            this.search()
          } else this.getBannedMembers()
          clearTimeout(this.timeout)
        }, 1000)
      }
    },
    created() {
    },
    mounted() {
      this.getBannedMembers()
    },
    methods: {
      search() {
        this.loading = true
        this.$axios({
          method: 'POST',
          url: `admin/members/membersearch`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || '',
            'criteria': this.searchCriteria
          }
        })
          .then((res) => {
            this.members = res.data.members
            if (!res.data.members.length) {
              this.$emit('message',
                {
                  showDialog: true,
                  error: false,
                  message: 'Members not found'
                })
            }
            this.loading = false
          })
          .catch((error) => {
            this.$emit('message', {error: true, message: error.response.data.message})
            this.loading = false
          })
      },
      getBannedMembers() {
        this.loading = true
        this.$axios({
          method: 'POST',
          url: `admin/members/bans/list`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || '',
            'criteria': this.searchCriteria
          }
        })
          .then((res) => {
            this.members = res.data
            this.loading = false
          })
          .catch((error) => {
            this.$emit('message', {error: true, message: error.response.data.message})
            this.loading = false
          })
      },
      close() {
        this.banModal = false
        this.unbanModal = false
      },
      openBanModal(member) {
        this.selectedMember = member
        this.banModal = true
      },
      openUnbanModal(member) {
        this.selectedMember = member
        this.unbanModal = true
      },
      banMember(payload) {
        this.$axios({
          method: 'POST',
          url: `admin/members/bans/ban`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || '',
            ahlid: payload.ahlid,
            reason: payload.reason,
            duration: payload.duration
          }
        })
          .then((res) => {
            this.$emit('message',
              {
                showDialog: true,
                error: false,
                message: 'Member has been banned'
              })
            this.members.find(m => m.ahlid === payload.ahlid).isBanned = '1'
            let member = this.members.find(m => m.ahlid === payload.ahlid)
            member.isBanned = '0'
            member.reason = payload.reason
            member.duration = payload.duration
            this.close()
            this.getBannedMembers()
          })
          .catch((error) => {
            this.$emit('message', {error: true, message: error.response.data.message})
          })
      },
      unbanMember(ahlid) {
        this.$axios({
          method: 'POST',
          url: `admin/members/bans/unban`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || '',
            ahlid
          }
        })
          .then((res) => {
            this.$emit('message',
              {
                error: false,
                message: 'Member has been unbanned'
              })
            let member = this.members.find(m => m.ahlid === ahlid)
            member.isBanned = '0'
            member.reason = ''
            member.duration = ''
            this.close()
            this.getBannedMembers()
          })
          .catch((error) => {
            this.$emit('message', {error: true, message: error.response.data.message})
          })
      }
    }
  }
</script>
